export const PROMO_GUIDE_SHEET_LINK = 'https://f.sravni.ru/cms/actions/mfo/action5_mfo_apr_2025.pdf';
